import { render, staticRenderFns } from "./hjlbTJ.vue?vue&type=template&id=0b31108a&scoped=true"
import script from "./hjlbTJ.vue?vue&type=script&lang=js"
export * from "./hjlbTJ.vue?vue&type=script&lang=js"
import style0 from "./hjlbTJ.vue?vue&type=style&index=0&id=0b31108a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b31108a",
  null
  
)

export default component.exports